import { apiRequest } from './core/client';

export interface SenderProfileContact {
  id: string;
  accountId: string;
  approvedState: 'pending' | 'approved' | 'blocked' | null;
  notificationsEnabled: boolean;
  unsubscribedAt: string | null;
  unsubscribeMethod: 'one_click' | 'mailto' | 'link' | null;
}

export interface SenderProfile {
  email: string;
  name: string | null;
  contacts: SenderProfileContact[];
  stats: {
    total: number;
    last30d: number;
    unread: number;
    firstMessageAt: string | null;
    lastMessageAt: string | null;
  };
  histogram: Array<{ week: string; count: number }>;
  recentMessages: Array<{
    id: string;
    accountId: string;
    subject: string | null;
    date: string | null;
    seen: boolean;
  }>;
  labels: Array<{ id: string; name: string; color: string | null; type: 'ai' | 'sender' }>;
  unsubscribe: { url: string | null; oneClick: boolean } | null;
  tracking: {
    trackedSends: number;
    openedSends: number;
    lastOpenedAt: string | null;
  };
}

export async function fetchSenderProfile(
  accountId: string,
  email: string
): Promise<SenderProfile> {
  return await apiRequest<SenderProfile>({
    path: '/senders/profile',
    accountId,
    query: { email },
  });
}
